module.exports = __webpack_public_path__ + "img/horizontal_3_4_r_7005.dfdf1fc3.png";